export default __webpack_public_path__ + "static/media/Baccarat-1-2-1edit.f794995b.webp";